export class GeometryUtility {
    /**
     * 
     * @param {*} pointStrings  x,y;x,y;
     */
    static getPointsEx(pointStrings) {
        let pnts = new Array();
        if (!pointStrings) return pnts;

        let pointStringSplits = pointStrings.split(";");


        let tempPntString = null;
        let tempPntStringSplitArray = null;
        let tempPntX = null;
        let tempPntY = null;
        let tempCoordinate = null;
        for (let pntIndex = 0; pntIndex < pointStringSplits.length; pntIndex++) {
            tempPntString = pointStringSplits[pntIndex];
            if (!tempPntString) continue;


            tempPntStringSplitArray = tempPntString.split(",");
            if (!tempPntStringSplitArray || tempPntStringSplitArray.length != 2) continue;
            tempPntX = parseFloat(tempPntStringSplitArray[0]);
            tempPntY = parseFloat(tempPntStringSplitArray[1]);
            tempCoordinate = [tempPntX, tempPntY];
            pnts.push(tempCoordinate);
        }

        return pnts;

    }

    /**
     * 
     * @param {*} pointStrings [[x,y],[x,y]]
     */
    static getPoints(pointStrings) {
        let pnts = new Array();
        if (!pointStrings) return pnts;

        let tempPntString = null;
        let tempPntStringSplitArray = null;
        let tempPntX = null;
        let tempPntY = null;
        let tempCoordinate = null;
        for (let pntIndex = 0; pntIndex < pointStrings.length; pntIndex++) {
            tempPntString = pointStrings[pntIndex];
            if (!tempPntString) continue;

            tempPntStringSplitArray = tempPntString.split(",");
            if (!tempPntStringSplitArray || tempPntStringSplitArray.length != 2) continue;
            tempPntX = parseFloat(tempPntStringSplitArray[0]);
            tempPntY = parseFloat(tempPntStringSplitArray[1]);
            tempCoordinate = [tempPntX, tempPntY];
            pnts.push(tempCoordinate);
        }

        return pnts;
    }


    static getPointsEx2(pointStrings) {
        let pnts = new Array();
        if (!pointStrings) return pnts;

        let pointStringSplits = pointStrings.split(",");

        let tempPntX = null;
        let tempPntY = null;
        let tempCoordinate = null;
        for (let pntIndex = 0; pntIndex < pointStringSplits.length; pntIndex = pntIndex + 2) {

            tempPntX = parseFloat(pointStringSplits[pntIndex]);
            tempPntY = parseFloat(pointStringSplits[pntIndex + 1]);
            tempCoordinate = [tempPntX, tempPntY];
            pnts.push(tempCoordinate);
        }

        return pnts;

    }


    /**
     * 转换坐标系
     * @param {*} oriPnts 
     * @param {*} oriEPSG 
     * @param {*} targetEPSG 
     */
    static transformPoints(oriPnts, oriEPSG, targetEPSG) {
        let targetPnts = new Array();

        if (!oriPnts || !oriEPSG || !targetEPSG) return;

        let tempOriPnt = null;
        let tempTargetPnt = null;
        for (let tempIndex = 0; tempIndex < oriPnts.length; tempIndex++) {
            tempOriPnt = oriPnts[tempIndex];

            tempTargetPnt = ol.proj.transform(
                tempOriPnt,
                oriEPSG,
                targetEPSG
            );

            targetPnts.push(tempTargetPnt);
        }


        return targetPnts;
    }

    static isGeoPoint() {


    }

    /**
     * 获取平面距离
     * @param {*} line 
     * @param {*} oriEPSG 
     */
    static getPolylineLength(line, oriEPSG) {
        let length = 0;

        //获取坐标串
        var coordinates = line.getCoordinates();
        if (oriEPSG != "EPSG:4326") {
            coordinates = GeometryUtility.transformPoints(coordinates, oriEPSG, "EPSG:4326");
        }

        //进行点的坐标转换
        for (var i = 0; i < coordinates.length - 1; i++) {

            length += ol.sphere.getDistance(coordinates[i], coordinates[i + 1]);
        }


        return length;
    }

    static getPolygonArea(pyn) {




    }


}
